var loginPhoneController = {
    itiLoginPhone: null,
    loginModal: $('#loginModal'),
    elForm: $('#loginPhone'),
    phone: '',
    password: '',
    init: function(itiLoginPhone)
    {
        loginPhoneController.itiLoginPhone = itiLoginPhone;
        loginPhoneController.elForm.find('.error-text').hide();

        loginPhoneController.phone = loginPhoneController.elForm.find('.js-input-phone-number').val();
        loginPhoneController.password = loginPhoneController.elForm.find('.js-input-password').val();

        loginPhoneController.elForm.find('.js-input-password').on('click change keyup blur input', function(){
            loginPhoneController.password = $(this).val().trim();
        });

        loginPhoneController.elForm.find('button').on('click', function() {
            loginPhoneController.submitForm();

            return false;
        });
    },
    submitForm: function()
    {
        loginPhoneController.phone = loginPhoneController.itiLoginPhone.getNumber();
        loginPhoneController.phone = loginPhoneController.phone.replace(/\D/g, "");

        if (!loginPhoneController.validateForm()) {
            loginPhoneController.showError();

            return false;
        }

        loginPhoneController.elForm.find('.js-input-phone-number').val(loginPhoneController.phone);

        $.post(
            loginPhoneController.elForm.attr('action'),
            loginPhoneController.elForm.serialize(),
            function(data){
                if (data.success) {
                    if (conversionDeferredEvent.isSetConversion()) {
                        conversionDeferredEvent.triggerEvent();
                    }

                    window.location.href = URL_CONST.LOGIN_REDIRECT;
                } else {
                    loginPhoneController.showError();
                }
            }, 'json');
    },
    validateForm: function()
    {
        loginPhoneController.clearForm();
        return (loginPhoneController.itiLoginPhone.isValidNumber() && loginPhoneController.password.length > 5);
    },
    clearForm: function()
    {
        loginPhoneController.elForm.find('.form-group').removeClass('has-error');
        loginPhoneController.elForm.find('.error-text').hide();
    },
    showError: function()
    {
        loginPhoneController.elForm.find('.form-group').addClass('has-error');
        loginPhoneController.elForm.find('.error-text').show();
    }
};

$(function(){
    var loginPhoneInput = document.getElementById("loginPhoneIti");
    var itiLoginPhone = window.intlTelInput(loginPhoneInput, {
        initialCountry: "auto",
        separateDialCode: true,
        geoIpLookup: function (callback) {
            $.get('https://ipinfo.io', function () {
            }, "jsonp").always(function (resp) {
                var countryCode = (resp && resp.country) ? resp.country : "";
                callback(countryCode);
            });
        },
        utilsScript: "/js/plugins/intl-tel-input-17.0.0/build/js/utils.js" // just for formatting/placeholders etc
    });

    loginPhoneController.init(itiLoginPhone);
});
